import { styled } from '@mui/material/styles'
import { Box, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material'

export const PresetContainer = styled(Box)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.border.primary}`,
  display: 'flex',
  flexDirection: 'column',
  minWidth: '200px',
}))

export const PresetHeader = styled(Typography)(({ theme }) => ({
  padding: 2,
  backgroundColor: theme.palette.surface.secondary,
  height: '56px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  color: theme.palette.text.body.primary
}))

export const StyledRadioGroup = styled(RadioGroup)({
  height: '100%',
  paddingTop: '15px',
  '& .MuiFormControlLabel-root': {
    paddingLeft: '15px'
  }
})

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme, isselected }) => ({
  '.MuiFormControlLabel-label': {
    fontSize: '12px',
    color: isselected ? theme.palette.text.body.primary : theme.palette.text.body.tertiary,
    textAlign: 'center',
    '&.Mui-disabled': {
      color: theme.palette.text.body.tertiary,
      opacity: 0.5
    }
  }
}))

export const StyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.primary.main
  },
  '&.Mui-disabled': {
    opacity: 0.5
  }
}))
